export interface WordDocumentContext {
  name: string;
  text: string;
  wordCount: number;
  charCount: number;
  hasSelection: boolean;
}

export const EMPTY_WORD_DOC_CONTEXT: WordDocumentContext = {
  name: "",
  text: "",
  wordCount: 0,
  charCount: 0,
  hasSelection: false,
};

export interface HandoffPayload {
  source: string;
  action: string;
  documentName?: string;
  documentId?: string;
  timestamp: number;
  metadata?: Record<string, unknown>;
}
